module.exports = __webpack_public_path__ + "img/2017_bicol.d41bfc1e.jpg";